import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainApp from './MainApp';
import Dashboard from './main_dashboard';
import Authentications from '../Authentications/Authentications';
import BankAgent from '../Bankagent/bank_agent_UI';
import CreateApplication from '../Applications/CreateApplication';
import CreateTrigger from '../Trigger/CreateTrigger';
import ThreadsView from '../Threads/ThreadsView';
import ChatPage from '../Bankagent/bank_chat';

function MainRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MainApp />}>
        <Route index element={<Dashboard />} />
        <Route path="authentications" element={<Authentications />} />
        <Route path="applications" element={<CreateApplication />} />
        <Route path="triggers" element={<CreateTrigger />} />
        <Route path="bank-agent" element={<BankAgent />} />
        <Route path="quote-agent" element={<ThreadsView />} />
        <Route path="chat" element={<ChatPage />} />
      </Route>
    </Routes>
  );
}

export default MainRoutes;
